import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ScrollAnimation from 'react-animate-on-scroll';

import {HomeWorkOutlined, VerifiedUserOutlined, WorkOutlineOutlined,} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingBottom: "100px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg1,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "0",
            paddingRight: "0",
        },
    },
    smContainer: {
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        padding: "10px",
        color: theme.palette.primary.main,
        transition: "0.5s",
        '& h3': {
            transition: "0.5s",
        },
        '& h6': {
            transition: "0.5s",
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: "white",
            '& h3': {
                color: 'white'
            },
            '& h6': {
                color: 'white'
            }
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
}))


export default function Tips() {
    const classes = useStyles();

    return (
        <React.Fragment>
            <div className={classes.container}>
                <Grid container direction="row">
                    <Grid item container direction="column" justify="center" className={classes.smContainer}>
                        <Grid item>
                            <Typography component="h1" variant="h1" align="center" paragraph
                                        style={{letterSpacing: "0"}}>
                                By utilizing an integrated team of professionals, we assure our clients a smooth, on
                                time and within budget completed work and above all a pleasant experience.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle2" align="center">
                                Our quality work, highly ethical and honest approach, and attention to details make us
                                stand out. Our goal is to find solutions that maximize client satisfaction while
                                minimizing the cost.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item container style={{marginTop: "50px", marginBottom: "40px"}}>
                        <Grid item container justify="center" alignItems="center" md={4} className={classes.box}>
                            <Grid item direction="column" container justify="flex-start" alignItems="center"
                                  style={{height: "100%"}}>
                                <VerifiedUserOutlined style={{fontSize: "4.5rem", marginBottom: "10px"}}/>

                                <ScrollAnimation animateIn="fadeInDown" animateOnce={true}>
                                    <Typography component="h1" variant="h3" align="center" style={{lineHeight: 2}}>
                                        Architects
                                    </Typography>

                                    <Typography variant="subtitle2" align="center">
                                        Our staff are construction experts with many high quality experiences ready to
                                        build
                                        and deliver high quality offices that last for generations.
                                    </Typography>
                                </ScrollAnimation>
                            </Grid>
                        </Grid>

                        <Grid item container justify="center" alignItems="center" md={4} className={classes.box}>
                            <Grid item direction="column" container justify="flex-start" alignItems="center">
                                <WorkOutlineOutlined style={{fontSize: "4.5rem", marginBottom: "10px"}}/>

                                <ScrollAnimation animateIn="fadeInDown" animateOnce={true}>
                                    <Typography component="h1" variant="h3" align="center" style={{lineHeight: 2}}>
                                        More than 25 years of successful work
                                    </Typography>

                                    <Typography variant="subtitle2" align="center">
                                        We understand once you lease or purchase your office, you are to pay rent or
                                        mortgage on that property. We are dedicated to complete your project as fast as
                                        possible without compromising the quality of work.
                                    </Typography>
                                </ScrollAnimation>
                            </Grid>
                        </Grid>

                        <Grid item container justify="center" alignItems="center" md={4} className={classes.box}>
                            <Grid item direction="column" container justify="flex-start" alignItems="center"
                                  style={{height: "100%"}}>
                                <HomeWorkOutlined style={{fontSize: "4.5rem", marginBottom: "10px"}}/>

                                <ScrollAnimation animateIn="fadeInDown" animateOnce={true}>
                                    <Typography component="h1" variant="h3" align="center" style={{lineHeight: 2}}>
                                        Modern design
                                    </Typography>

                                    <Typography variant="subtitle2" align="center">
                                        Our professionally designed dental/medical offices will enhance your practice by
                                        improving: profitability, efficiency, productivity and staff/patient
                                        satisfaction
                                        and retention.
                                    </Typography>
                                </ScrollAnimation>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </div>
        </React.Fragment>

    )
        ;
}
